"use client"

import { PublicErrorBoundary } from "@/components/public-error-boundary"

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return <PublicErrorBoundary error={error} reset={reset} source="app-error-boundary" mode="graceful" />
}
